import React from "react";
import { Redirect } from "react-router-dom";

// User profile
import LabProfile from "../pages/Authentication/LabProfile";

import StaffProfile from "../pages/Authentication/StaffProfile";
// LabMarket Pages
import NearbyLabs from "../pages/LabMarket/NearbyLabs/index";
import StaffList from "pages/databaseadmin/staff-list";
import NearbyLabDetail from "pages/LabMarket/NearbyLabs/NearbyLabDetail";

// TestMarket Pages
import labs from "pages/LabMarket/NearbyLabs/labs";

///accountant
import DashboardAccountant from "pages/Dashboard-Accountant";
///dispatcher
import DashboardDispatcher from "pages/Dashboard-Dispatcher";

//ContactUs
import ContactUs from "../pages/Contact/contact-us";
import ChatBox from "../pages/Public/chat";
// Authentication related pages
import Login from "../pages/Authentication/Login";
import RegisterAffiliate from "../pages/Authentication/RegisterAffiliate";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import LabInformation from "../pages/Authentication/LabInformation";

import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ConfirmPwd from "../pages/Authentication/ConfirmPassword";

// Dashboard
import DashboardLab from "../pages/Dashboard-Lab/index";
// import DashboardFinanceOfficer from "pages/Dashboard-FinanceOfficer/StackedColumnChart";
import FinanceOfficerProfile from "../pages/Authentication/StaffProfile";
import DashboardFinance from "../pages/Dashboard-Finance/index";
import DashboardOrganization from "../pages/Dashboard-Organization";
import AddCSR from "pages/databaseadmin/add-csr";
//Database Admin
import DashboardatabaseAdmin from "pages/Dashboard-DatabaseAdmin";
import DatabaseOfUnitsPage from "pages/databaseadmin/database-of-units";
import DatabaseOfQualitativeTypePage from "pages/databaseadmin/database-of-qualitativetype";
import DeletedParticipants from "pages/databaseadmin/deleted-participants";
import SampleListAnalytes from "pages/databaseadmin/sample-analyte";
import DatabaseOfReagentsPage from "pages/databaseadmin/database-of-reagents";
import DatabaseOfManufactural from "pages/databaseadmin/database-of-manufactural";
import DatabaseOfMethod from "pages/databaseadmin/method-list";
import DatabaseOfAnalyte from "pages/databaseadmin/database-of-analyte";
import AnalyteAddMethods from "pages/databaseadmin/analyte-add-methods";
import AnalyteAddUnits from "pages/databaseadmin/analyte-add-units";
import AnalyteAddQualitativeUnits from "pages/databaseadmin/analyte-add-qualitative-units";
import InstrumentAddAnalyte from "pages/databaseadmin/instrument-add-analyte";
import ReagentAddAnalyte from "pages/databaseadmin/reagent-add-analyte";
import MethodAddAnalyte from "pages/databaseadmin/method-add-analytes";
import DatabaseOfinsrumentType from "pages/databaseadmin/instrument-type-list";
import InstrumentList from "pages/databaseadmin/instruments-list";
import Scheme from "pages/databaseadmin/scheme";
import ParticipantListN from "pages/databaseadmin/participants";
import Cycle from "pages/databaseadmin/cycle";
import CycleAnalytes from "pages/databaseadmin/cycle-analyte";
import SchemeAnalytes from "pages/databaseadmin/add-analytes-scheme-page";
import SchemeListAnalyte from "pages/databaseadmin/scheme-analytelist";
import Sample from "pages/databaseadmin/sample";
import SampleAnalytes from "pages/databaseadmin/add-analytes-sample-page";
import SchemeDetailsReport from "pages/databaseadmin/schemedetails";
import PaymentDetail from "pages/databaseadmin/payment-detail";
import DeletedPayments from "pages/databaseadmin/payments-delete-list";
import FinanceReport from "pages/databaseadmin/Finance-Report";
import FinancialForecast from "pages/databaseadmin/Financial-Forecast";
import AnalyteAddReagents from "pages/databaseadmin/analyte-add-reagents";
import AnalyteAddEuipments from "pages/databaseadmin/analyte-add-equipments";
import DatabaseOfParticipantCity from "pages/databaseadmin/database-of-participantcity";
import EditParticipantsPage from "pages/databaseadmin/editparticipantsModal";
import Banks from "pages/databaseadmin/banks";
import DatabaseOfParticipantCountry from "pages/databaseadmin/database-of-participantcountry";
import DatabaseOfParticipantProvince from "pages/databaseadmin/database-of-participantprovince";
import InstrumentDetail from "pages/databaseadmin/instrument-list-detail";
import DatabaseOfParticipantDistrict from "pages/databaseadmin/database-of-participantdistrict";
import DatabaseOfParticipantDepartment from "pages/databaseadmin/database-of-participantdepartment";
import DatabaseOfParticipantDesignation from "pages/databaseadmin/database-of-participantdesignation";
import DatabaseOfParticipanttype from "pages/databaseadmin/database-of-participanttype";
import DatabaseOfParticipantSector from "pages/databaseadmin/database-of-participantsector";
import UnitsAnalytes from "pages/databaseadmin/units-analyte";
import InstrumentsInType from "pages/databaseadmin/instrumentsintype";
import InstrumentsInManufacturer from "pages/databaseadmin/instrumentsinmanufacturer";
import ReagentsInManufacturer from "pages/databaseadmin/reagentsinmanufacturer";
import Equipment1Detail from "pages/databaseadmin/EquipmentReport-1";
import Equipment2Detail from "pages/databaseadmin/EquipmentReport-2";
import RoundsParticipatedPage from "pages/databaseadmin/RoundsParticipatedPage";
import MethodsAnalytes from "pages/databaseadmin/methods-analyte";
import InstrumentsAnalytes from "pages/databaseadmin/instruments-analyte";
import databaseOfMicro from "pages/databaseadmin/database-of-micro";
import ReagentsAnalytes from "pages/databaseadmin/reagent-analyte";
import SchemeRoundList from "pages/databaseadmin/round-list";
import Membershipstatusreport from "pages/databaseadmin/participantreport";
import ParticipantCountReport from "pages/databaseadmin/participant_count_report";
import OrganinismList from "pages/databaseadmin/database-of-organism";
import Antibioticlist from "pages/databaseadmin/database-of-antibiotics";
import AnalyteReport1 from "pages/databaseadmin/AnalyteReport-1";
import AnalyteReport2 from "pages/databaseadmin/analytereport2";
import AnalyteEvaluationReport from "pages/databaseadmin/analytesevaluationreport";
import COACriteria from "pages/databaseadmin/COA-Criteria";
import DashboardCSRadmin from "pages/Dashboard-CSR";
//HR  Admin
import DatabaseadminList from "pages/HrAdmin/databaseadmin-list";
import DBAdminPaymentHistory from "pages/databaseadmin/PaymentHistory";
// import FinanceAdminProfile from "../pages/Authentication/StaffProfile";

// //Dashboard PArticipant
import DashboardPartcipant from "pages/Dashboard-Participant";
import Rounds from "pages/Participant/rounds";
import Performance from "pages/Participant/performance";
import Home from "pages/Participant/home";
import CertificateList from "pages/Participant/certificate_list";
import CurrentCycleCertificate from "pages/Participant/current_cycle_certificate";
import NewsPage from "pages/Participant/news-paritcipant";
import Email from "pages/Participant/email";
import AllParticipant from "pages/Participant/all-participants";
import AllParticipant1 from "pages/Participant/all-participants1";
import AllParticipant2 from "pages/Participant/all-participants1";
import ParticpantHistoryCSR from "pages/Participant/participant-history";
import ParticipantsResult from "pages/Participant/results";
import Report from "pages/Participant/report";
import SereologyReport from "pages/Participant/sereologyReport";
import UpdateParticipantsResult from "pages/RegistrationAdmin/results";
import AllLabsHistory from "pages/RegistrationAdmin/Alllabs-history";
import ResultHistory from "pages/Participant/result-history";
import ReportParticipant from "pages/Participant/report1_view";
import QualitativeReportParticipant from "pages/Participant/qualitative_report_view";
import RegQualitativeReportParticipant from "pages/Participant/reg_qualitative_report";
import QualitativeReportParticipant2 from "pages/databaseadmin/qualitative_report_db";
import RegMicroReport from "pages/Participant/reg_micro_report";
import MicroResults from "pages/Participant/microResult";
import MicroReport from "pages/Participant/micro-report";
import RegReportParticipant from "pages/Participant/reg_report1_view";
import CertificateParticipant from "pages/Participant/certificate";
import AchievementCertificate from "pages/Participant/certificate_of_achievement";
import COAVerification from "pages/Participant/COA-verification";
import COPVerification from "pages/Participant/COP-verification";
import CycleYearReport from "pages/databaseadmin/Cycle-Year-Report";

// Lab Componentsss
import SampleDispatchReport from "../pages/Authentication/Sample-Report";
import DeliveryChallan from "../pages/Authentication/Delivery_Challan";
import StockIn from "pages/databaseadmin/stock-in";
import StockOut from "pages/databaseadmin/stock-out";

import QualityCertificatesList from "../pages/QualityCertificates/quality-certificates-list";

import FeedbacksList from "../pages/Feedbacks/feedbacks-list";
import LabInvoiceDetail from "pages/Checkouts/invoice-detail";

// import checkout from "pages/Checkouts/checkout-list";
import Checkout from "pages/Checkouts/checkout";

import InvoiceDetail from "pages/Checkouts/invoice-detail";
import LabSettings from "pages/Authentication/LabSettings";
import FeedbackDetail from "pages/Feedbacks-List/FeedbackDetail";

// LAB ADV INVOICE
import AdvInvoiceDetail from "pages/advInvoice/adv-invoice-detail";
import AllLabsList from "pages/Admin/lab-labs-list";

import Disclaimer from "pages/Public/disclaimer";
import AboutUs from "pages/Public/about-us";
// import ChatBox from "pages/Public/chat";
// import TermsConditions from "pdf/LabHazir - Terms & Conditions.pdf";
import ChangePassword from "pages/Authentication/ChangePassword";

// registration admin
import AllLabs from "pages/RegistrationAdmin/All-participant";
import PendingLabs from "pages/RegistrationAdmin/pending-labs";
import Dashboardregistrationadmin from "pages/Dashboard-RegistrationAdmin";
import RoundLabs from "pages/RegistrationAdmin/add-labs-round-page";
import labsListApprovedFeeOffered from "pages/RegistrationAdmin/labs-list-approved-fee";
import labsListPendingFeeOffered from "pages/RegistrationAdmin/labs-list-pending-fee";
import sharedPercentagePendingFeeTests from "pages/RegistrationAdmin/shared-percentage-pending-Fee";
import sharedPercentageApprovedFeeTests from "pages/RegistrationAdmin/shared-percentage-approved-Fee";
import ApprovedLabs from "pages/RegistrationAdmin/approved-labs";
import UnapprovedLabs from "pages/RegistrationAdmin/unapproved-labs";
import SuspendedLabs from "pages/RegistrationAdmin/suspended-labs";
import rounds from "pages/RegistrationAdmin/rounds";
import ReferrelLab from "pages/RegistrationAdmin/referrelfeelab";
import ApproveReferrelLab from "pages/RegistrationAdmin/Approvereferrelfeelab";
import AllParticipantEditModal from "pages/RegistrationAdmin/All-participant-EditModal";
import AllParticipantPaymentModal from "pages/RegistrationAdmin/All-participant-PaymentModal";
import News from "pages/RegistrationAdmin/news";
import Comments from "pages/RegistrationAdmin/comments";
import Statistics from "pages/RegistrationAdmin/statics";
import SelectValues from "pages/RegistrationAdmin/reportValues";
import QualitativeStatistics from "pages/RegistrationAdmin/qualitativeStatic";
import DisplayValues from "pages/RegistrationAdmin/analteTypeValues";
import RoundsHistory from "pages/RegistrationAdmin/registrationadmin-history";
import RegParticipant from "pages/Authentication/RegisterParticipant";
import ResultParticipantlist from "pages/RegistrationAdmin/submitted-participants";
import ResultSavedParticipant from "pages/RegistrationAdmin/saved-participants";
import StatisticParticipant from "pages/RegistrationAdmin/statistic-participant";
import PendingSubmission from "pages/RegistrationAdmin/pending-submission";
import microReportStatistics from "pages/RegistrationAdmin/microReportStatistics";
import microReportValue from "pages/RegistrationAdmin/microReportValue";
import SummaryResults from "pages/RegistrationAdmin/microsummaryresult";
import QualitativeSummaryResults from "pages/RegistrationAdmin/qualitativeSummaryResult";
import NewReport from "pages/Participant/newreport";
import Help from "pages/Participant/help";
import AddPathologists from "pages/Participant/add-pathologists";
// finance admin
// Marketer Admin routes

import labList from "pages/Admin/labs-list";

// Discount of Labhazir to lab

// Registration of Marketer Admin

import MsgsList from "pages/Complaints/msg-box";

import LabAudits from "pages/Dashboard-Lab/lab-audits";
import activityLog from "pages/Dashboard-Lab/activity-log";

import PagesMaintenance from "pages/Utility/pages-maintenance";
import PagesComingsoon from "pages/Utility/pages-comingsoon";
import Pages404 from "pages/Utility/pages-404";
import Pages500 from "pages/Utility/pages-500";

import StaffRegister from "pages/HrAdmin/staff-register";
import OrganizationRegister from "pages/HrAdmin/organization-register";
import OrganizationList from "pages/SuperAdmin/organization-list";

import StaffInfo from "pages/HrAdmin/staff-info";

import Payments from "pages/Authentication/Payments";
import UnitsHistory from "../pages/databaseadmin/databaseadmin-history";

import { invoiceList } from "common/data";
import labsListPendingFee from "store/labs-list-pending/reducer";

import msgBox from "pages/Complaints/msg-box";
import msgBoxFo from "pages/Complaints/msg-box";

import { components } from "react-select/dist/react-select.cjs.prod";
// import RegParticipant from "pages/RegisterParticipant";
// import RegParticipant from "pages/Authentication/RegisterParticipant";
import RegistrationAdminList from "pages/HrAdmin/registration-admin-list";
import RegParticipantCSR from "pages/Authentication/RegisterParticipantCSR";
import ParticipantPayments from "pages/Authentication/participant-payment";
import PaymentSchemeList from "pages/Authentication/payment-scheme-list";
import RoundParticipantlist from "pages/RegistrationAdmin/round-participant-list";
import UpdateMicroResult from "pages/RegistrationAdmin/update_microresult";
import csrList from "pages/HrAdmin/csr-list";
import AccountantList from "pages/HrAdmin/accountant-list";
import DispatcherList from "pages/HrAdmin/dispatcher-list";
import DispatcherHistory from "pages/HrAdmin/dispatcher-history";
import organizationList from "pages/HrAdmin/organizationList";
import RegisterParticipant from "pages/Authentication/RegisterParticipant";
import ParticipantCSRPayments from "pages/Authentication/PaymentCSR";
import PaymentCSRSchemeList from "pages/Authentication/PaymentCSR-scheme-list";
import InstrumentType2 from "pages/Authentication/CSRrounds";
import RoundParticipantlist2 from "pages/Authentication/CSRroundparticipants";
import SubmittedResults from "pages/Authentication/CSRroundsubmittedresults";
import PendingSubmission2 from "pages/Authentication/CSRroundpendingsubmission";
import CSRHistory from "pages/Authentication/CSRhistory";
import Csrcomments from "pages/Authentication/csrcomments";
import PendingCSRLabs from "pages/Authentication/CSRPendinglabs";
import ApprovedCSRLabs from "pages/Authentication/approvedCSRlabs";
import UnapprovedCSRLabs from "pages/Authentication/UnapprovedCSRlabs";
import SuspendedCSRLabs from "pages/Authentication/suspendedCSRlabs";
import CSRroundHistory from "pages/Authentication/CSRroundHistory";
import ResultParticipantlist2 from "pages/Authentication/savedresultscsr";
import CSRAllParticipantPaymentModal from "pages/Authentication/csrAllpartcicpantpaymentmodal";
import CommentsCycleRenew2 from "pages/Authentication/csrcommentscyclerenew";
import SchemeDetailsReport2 from "pages/Authentication/csrschemedetails";
import CommentsCycleRenew from "pages/databaseadmin/commentscyclerenew";
import RenewalParticipants from "pages/databaseadmin/RenewalParticipant";
import PartialPayment2 from "pages/RegistrationAdmin/partialpayment2";
import PartialPayment from "pages/Participant/partialpayment";
import RenewalParticipantCsr from "pages/Authentication/RenewalParticipantCsr";
import AccountantHistory from "pages/Dashboard-Accountant/accountant-History";
import Paymentstatement from "pages/Dashboard-Accountant/payment-statement";
// All general public routes will be listed here
const publicRoutes = [
  { path: "/register/:guest_id?/:uuid?", component: Register },
  { path: "/logout", component: Logout },
  { path: "/login/:guest_id?/:uuid?", component: Login },
  { path: "/register-affiliate", component: RegisterAffiliate },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/:token/confirm-password", component: ConfirmPwd },
  { path: "/change-password", component: ChangePassword },

  // { path: "/register-participant-copy", component: RegParticipantCopy},

  { path: "/lab-information/:id", component: LabInformation },

  { path: "/nearby-labs/:uuid?/:guest_id?", component: NearbyLabs },
  { path: "/contact-us", component: ContactUs },
  {
    path: "/:organization_name/:id/COA-verification",
    component: COAVerification,
  },
  {
    path: "/:organization_name/:id/COP-verification",
    component: COPVerification,
  },
  {
    path: "/:organization_name/:id/certificate",
    component: CertificateParticipant,
  },
  {
    path: "/:organization_name/:id/certificate_of_achievement",
    component: AchievementCertificate,
  },
  // {
  //   path: "/labs/:uuid?",
  //   component: labs,
  // },
  // {
  //   path: "/nearby-tests/:guest_id?/:uuid?",
  //   component: NearbyTests,
  // },
  // {  path: "/nearby-profiles/:guest_id?/:uuid?",
  //    component: NearbyProfiles
  // },
  // {  path: "/nearby-packages/:guest_id?/:uuid?",
  //   component: NearbyPackages
  // },
  // {
  //   path: "/nearby-lab-detail/:lab_account_id/:guest_id?/:uuid?",
  //   component: NearbyLabDetail,
  // },
  // {
  //   path: "/:lab_account_id/offered-test-by-lab/:guest_id?/:uuid?",
  //   component: TestsOfferedbyLab,
  // },
];

const labAuthProtectedRoutes = [
  { path: "/change-password", component: ChangePassword },
  { path: "/dashboard-lab", component: DashboardLab },

  {
    path: "/lab-profile",
    component: LabProfile,
  },
  {
    path: "/lab-settings",
    component: LabSettings,
  },

  {
    path: "/lab-payments/:id",
    component: Payments,
  },
  {
    path: "/:organization_name/:id/certificate",
    component: CertificateParticipant,
  },
  {
    path: "/:organization_name/:id/certificate_of_achievement",
    component: AchievementCertificate,
  },
  {
    path: "/:organization_name/:id/COA-verification",
    component: COAVerification,
  },
  {
    path: "/:organization_name/:id/COP-verification",
    component: COPVerification,
  },
];

const financeOfficerAuthProtectedRoutes = [
  { path: "/dashboard-finance", component: DashboardFinance },
  { path: "/financeofficer-profile", component: FinanceOfficerProfile },
];
const databaseAdminAuthProtectedRoutes = [
  {
    path: "/:organization_name/dashboard-databaseadmin",
    component: DashboardatabaseAdmin,
  },
  { path: "/:organization_name/add-csr", component: AddCSR },
  {
    path: "/:organization_name/database-of-units",
    component: DatabaseOfUnitsPage,
  },
  {
    path: "/:organization_name/deleted-participants",
    component: DeletedParticipants,
  },
  {
    path: "/:organization_name/database-of-qualitativetype",
    component: DatabaseOfQualitativeTypePage,
  },
  {
    path: "/:organization_name/RenewalParticipant/:id",
    component: RenewalParticipants,
  },
  {
    path: "/:organization_name/database-of-reagents",
    component: DatabaseOfReagentsPage,
  },
  {
    path: "/:organization_name/editdata/:id",
    component: EditParticipantsPage,
  },
  { path: "/:organization_name/Cycle-Year-Report", component: CycleYearReport },
  {
    path: "/:organization_name/PaymentHistory/:id",
    component: DBAdminPaymentHistory,
  },
  { path: "/:organization_name/COA-Criteria", component: COACriteria },
  { path: "/:organization_name/equipment-list", component: InstrumentList },
  {
    path: "/:organization_name/database-of-equipmentType",
    component: DatabaseOfinsrumentType,
  },
  { path: "/instrument-add-analyte/:id", component: InstrumentAddAnalyte },
  { path: "/reagent-add-analyte/:id", component: ReagentAddAnalyte },
  { path: "/method-add-analytes/:id", component: MethodAddAnalyte },
  { path: "/instrument-list-detail/:id", component: InstrumentDetail },
  {
    path: "/:organization_name/database-of-manufactural",
    component: DatabaseOfManufactural,
  },
  {
    path: "/:organization_name/staff-list",
    component: StaffList,
  },
  {
    path: "/:organization_name/EquipmentReport-1",
    component: Equipment1Detail,
  },
  {
    path: "/:organization_name/EquipmentReport-2",
    component: Equipment2Detail,
  },
  { path: "/equipment-report/rounds", component: RoundsParticipatedPage },
  {
    path: "/:organization_name/database-of-method",
    component: DatabaseOfMethod,
  },
  { path: "/:organization_name/AnalyteReport-1", component: AnalyteReport1 },
  { path: "/:organization_name/analytereport2", component: AnalyteReport2 },
  {
    path: "/:organization_name/analytesevaluationreport",
    component: AnalyteEvaluationReport,
  },
  {
    path: "/:organization_name/database-of-analyte",
    component: DatabaseOfAnalyte,
  },
  {
    path: "/:organization_name/databaseadmin-history/:id",
    component: UnitsHistory,
  },
  {
    path: "/:organization_name/sample-analyte/:id",
    component: SampleListAnalytes,
  },
  { path: "/:organization_name/scheme", component: Scheme },
  { path: "/:organization_name/cycle", component: Cycle },
  { path: "/:organization_name/cycle-analyte/:id", component: CycleAnalytes },
  { path: "/add-analytes-scheme-page/:id", component: SchemeAnalytes },
  { path: "/:organization_name/sample", component: Sample },
  { path: "/add-analytes-sample-page/:id", component: SampleAnalytes },
  { path: "/scheme-analytelist/:id", component: SchemeListAnalyte },
  { path: "/:organization_name/schemedetails", component: SchemeDetailsReport },
  { path: "/:organization_name/payment-detail", component: PaymentDetail },
  {
    path: "/:organization_name/payments-delete-list",
    component: DeletedPayments,
  },
  { path: "/:organization_name/Finance-Report", component: FinanceReport },
  {
    path: "/:organization_name/Financial-Forecast",
    component: FinancialForecast,
  },
  {
    path: "/:organization_name/analyte-add-methods/:id",
    component: AnalyteAddMethods,
  },
  {
    path: "/:organization_name/analyte-add-units/:id",
    component: AnalyteAddUnits,
  },
  { path: "/:organization_name/database-of-micro", component: databaseOfMicro },
  {
    path: "/analyte-add-qualitative-units/:id",
    component: AnalyteAddQualitativeUnits,
  },
  {
    path: "/:organization_name/analyte-add-reagents/:id",
    component: AnalyteAddReagents,
  },
  {
    path: "/:organization_name/analyte-add-equipments/:id",
    component: AnalyteAddEuipments,
  },
  { path: "/units-analytes/:id", component: UnitsAnalytes },
  { path: "/methods-analyte/:id", component: MethodsAnalytes },
  { path: "/instruments-analyte/:id", component: InstrumentsAnalytes },
  { path: "/reagents-analyte/:id", component: ReagentsAnalytes },
  { path: "/instruments-in-type/:id", component: InstrumentsInType },
  {
    path: "/instruments-in-manufacturer/:id",
    component: InstrumentsInManufacturer,
  },
  { path: "/reagents-in-manufacturer/:id", component: ReagentsInManufacturer },
  { path: "/round-list/:id", component: SchemeRoundList },
  { path: "/:organization_name/participants", component: ParticipantListN },
  {
    path: "/:organization_name/database-of-organism",
    component: OrganinismList,
  },
  {
    path: "/:organization_name/database-of-antibiotics",
    component: Antibioticlist,
  },

  //participant data
  {
    path: "/:organization_name/database-of-participantcity",
    component: DatabaseOfParticipantCity,
  },

  { path: "/:organization_name/banks", component: Banks },

  {
    path: "/:organization_name/database-of-participantcountry",
    component: DatabaseOfParticipantCountry,
  },
  {
    path: "/:organization_name/database-of-participantprovince",
    component: DatabaseOfParticipantProvince,
  },
  {
    path: "/:organization_name/database-of-participantdistrict",
    component: DatabaseOfParticipantDistrict,
  },
  {
    path: "/:organization_name/database-of-participantdepartment",
    component: DatabaseOfParticipantDepartment,
  },
  {
    path: "/:organization_name/database-of-participantdesignation",
    component: DatabaseOfParticipantDesignation,
  },
  {
    path: "/:organization_name/database-of-participanttype",
    component: DatabaseOfParticipanttype,
  },
  {
    path: "/:organization_name/database-of-participantSector",
    component: DatabaseOfParticipantSector,
  },
  {
    path: "/:organization_name/participantreport",
    component: Membershipstatusreport,
  },
  {
    path: "/:organization_name/participant_count_report",
    component: ParticipantCountReport,
  },
  {
    path: "/:organization_name/:id/:id1/qualitative_report_db",
    component: QualitativeReportParticipant2,
  },
  {
    path: "/:organization_name/commentscyclerenew",
    component: CommentsCycleRenew,
  },
];
const participantsAuthProtectedRoutes = [
  {
    path: "/:organization_name/dashboard-participant",
    component: DashboardPartcipant,
  },
  { path: "/:organization_name/rounds-participant", component: Rounds },
  { path: "/:organization_name/performance", component: Performance },
  { path: "/:organization_name/home", component: Home },
  { path: "/:organization_name/certificate_list", component: CertificateList },
  {
    path: "/:organization_name/current_cycle_certificate",
    component: CurrentCycleCertificate,
  },
  { path: "/:organization_name/newspage", component: NewsPage },
  { path: "/email", component: Email },
  {
    path: "/:organization_name/:id/:id1/participantsResults",
    component: ParticipantsResult,
  },
  { path: "/:organization_name/:id/:id1/report", component: Report },
  {
    path: "/:organization_name/:id/:id1/sereology-report",
    component: SereologyReport,
  },
  {
    path: "/:organization_name/rounds-history/participant/:id",
    component: RoundsHistory,
  },
  { path: "/:organization_name/add-pathologists", component: AddPathologists },
  {
    path: "/:organization_name/result-history/participant/:id",
    component: ResultHistory,
  },
  {
    path: "/:organization_name/:id/:id1/report1_view",
    component: ReportParticipant,
  },
  {
    path: "/:organization_name/:id/:id1/qualitative_report_view",
    component: QualitativeReportParticipant,
  },
  { path: "/:organization_name/:id/:id1/microResult", component: MicroResults },
  { path: "/:organization_name/:id/:id1/micro-report", component: MicroReport },
  { path: "/:organization_name/newreport", component: NewReport },
  { path: "/:organization_name/help", component: Help },
  {
    path: "/:organization_name/:id/certificate_of_achievement",
    component: AchievementCertificate,
  },
  {
    path: "/:organization_name/:id/certificate",
    component: CertificateParticipant,
  },

  {
    path: "/:organization_name/:id/COA-verification",
    component: COAVerification,
  },
  {
    path: "/:organization_name/:id/COP-verification",
    component: COPVerification,
  },
];

const registrationAdminAuthProtectedRoutes = [
  {
    path: "/:organization_name/partialpayment2/:id",
    component: PartialPayment2,
  },
  {
    path: "/:organization_name/dashboard-registrationadmin",
    component: Dashboardregistrationadmin,
  },
  {
    path: "/:organization_name/Alllabs-History/:id",
    component: AllLabsHistory,
  },
  {
    path: "/:organization_name/UpdateParticipantsResults/:id",
    component: UpdateParticipantsResult,
  },
  {
    path: "/:organization_name/:id/:id1/reg_report1_view",
    component: RegReportParticipant,
  },
  { path: "/:organization_name/round", component: rounds },
  { path: "/:organization_name/all-participant", component: AllLabs },
  { path: "/:organization_name/add-labs-round-page/:id", component: RoundLabs },
  { path: "/:organization_name/pending-participant", component: PendingLabs },
  { path: "/labs-list-approved-fee", component: labsListApprovedFeeOffered },
  { path: "/labs-list-pending-fee", component: labsListPendingFeeOffered },
  {
    path: "/:organization_name/update_microresult/:id",
    component: UpdateMicroResult,
  },
  {
    path: "/:organization_name/shared-percentage-pending-Fee/:id",
    component: sharedPercentagePendingFeeTests,
  },
  { path: "/round-participant-list/:id", component: RoundParticipantlist },
  {
    path: "/:organization_name/register-participant",
    component: RegParticipant,
  },
  {
    path: "/:organization_name/participant-payment",
    component: ParticipantPayments,
  },
  {
    path: "/:organization_name/editlabdata/:id",
    component: AllParticipantEditModal,
  },
  {
    path: "/:organization_name/payment/:participantId",
    component: AllParticipantPaymentModal,
  },
  {
    path: "/:organization_name/:id/:id1/reg_qualitative_report",
    component: RegQualitativeReportParticipant,
  },
  {
    path: "/:organization_name/shared-percentage-approved-Fee/:id",
    component: sharedPercentageApprovedFeeTests,
  },
  { path: "/:organization_name/approved-participant", component: ApprovedLabs },
  {
    path: "/:organization_name/unapproved-participant",
    component: UnapprovedLabs,
  },
  {
    path: "/:organization_name/suspended-participant",
    component: SuspendedLabs,
  },
  { path: "/payment-scheme-list/:id", component: PaymentSchemeList },
  {
    path: "/referrellab",
    component: ReferrelLab,
  },
  {
    path: "/approvereferrellab",
    component: ApproveReferrelLab,
  },
  { path: "/:organization_name/all-participant1", component: AllParticipant1 },
  { path: "/:organization_name/news", component: News },
  { path: "/comments/:id/:schemeId/:roundId", component: Comments },
  { path: "/:organization_name/statistics/:id", component: Statistics },
  {
    path: "/:organization_name/qualitativeStatic/:id",
    component: QualitativeStatistics,
  },
  { path: "/:organization_name/slectValues/:id", component: SelectValues },
  { path: "/:organization_name/displayValues/:id", component: DisplayValues },
  { path: "/:organization_name/rounds-history/:id", component: RoundsHistory },
  { path: "/:organization_name/:id/participant-report", component: Report },
  { path: "/submitted-participants/:id", component: ResultParticipantlist },
  { path: "/saved-participants/:id", component: ResultSavedParticipant },
  {
    path: "/statistic-participant/:scheme_id/:roundId/:analyteId",
    component: StatisticParticipant,
  },
  { path: "/pending-submission/:id", component: PendingSubmission },
  {
    path: "/:organization_name/microReportValue/:id",
    component: microReportValue,
  },
  {
    path: "/:organization_name/microReportStatistics/:id",
    component: microReportStatistics,
  },
  {
    path: "/:organization_name/microsummaryresult/:id",
    component: SummaryResults,
  },
  {
    path: "/:organization_name/qalitativeSummaryResult/:id",
    component: QualitativeSummaryResults,
  },
  {
    path: "/:organization_name/:id/:id1/reg_micro_report",
    component: RegMicroReport,
  },
];

//CSR
const CSRAdminAuthProtectedRoutes = [
  { path: "/:organization_name/partialpayment/:id", component: PartialPayment },
  {
    path: "/:organization_name/register-participant-CSR",
    component: RegParticipantCSR,
  },
  {
    path: "/:organization_name/Dashboard-CSR",
    component: DashboardCSRadmin,
  },
  { path: "/:organization_name/all-participant2", component: AllParticipant2 },
  { path: "/:organization_name/CSRrounds", component: InstrumentType2 },
  {
    path: "/:organization_name/CSRroundparticipants/:id",
    component: RoundParticipantlist2,
  },
  {
    path: "/:organization_name/csrpayment/:participantId",
    component: AllParticipantPaymentModal,
  },
  {
    path: "/:organization_name/csrAllpartcicpantpaymentmodal/:participantId",
    component: CSRAllParticipantPaymentModal,
  },
  {
    path: "/:organization_name/CSRroundsubmittedresults/:id",
    component: SubmittedResults,
  },
  {
    path: "/:organization_name/Sample-Report",
    component: SampleDispatchReport,
  },
  {
    path: "/:organization_name/Delivery_Challan",
    component: DeliveryChallan,
  },
   { path: "/:organization_name/stock-in", component: StockIn },
      { path: "/:organization_name/stock-out", component: StockOut },
  {
    path: "/:organization_name/CSRroundHistory/:id",
    component: CSRroundHistory,
  },
  {
    path: "/:organization_name/CSRroundpendingsubmission/:id",
    component: PendingSubmission2,
  },
  { path: "/:organization_name/CSRhistory", component: CSRHistory },
  {
    path: "/:organization_name/participant-history/:id",
    component: ParticpantHistoryCSR,
  },
  {
    path: "/:organization_name/csrcomments/:id/:schemeId/:roundId",
    component: Csrcomments,
  },
  { path: "/:organization_name/PaymentCSR", component: ParticipantCSRPayments },
  { path: "/PaymentCSR-scheme-list/:id", component: PaymentCSRSchemeList },
  {
    path: "/:organization_name/PaymentHistory/:id",
    component: DBAdminPaymentHistory,
  },
  // ✅ FIXED: removed /:id since PendingLabs pushes without an id
  { path: "/:organization_name/CSRPendinglabs", component: PendingCSRLabs },
  { path: "/:organization_name/approvedCSRlabs", component: ApprovedCSRLabs },
  {
    path: "/:organization_name/UnapprovedCSRlabs",
    component: UnapprovedCSRLabs,
  },
  { path: "/:organization_name/suspendedCSRlabs", component: SuspendedCSRLabs },
  { path: "/savedresultscsr/:id", component: ResultParticipantlist2 },
  {
    path: "/:organization_name/csrschemedetails",
    component: SchemeDetailsReport2,
  },
  {
    path: "/:organization_name/csrcommentscyclerenew",
    component: CommentsCycleRenew2,
  },
  {
    path: "/:organization_name/RenewalParticipantCsr/:id",
    component: RenewalParticipantCsr,
  },
  // ✅ Certificate routes moved ABOVE the generic /:id routes to avoid conflicts
  {
    path: "/:organization_name/:id/certificate_of_achievement",
    component: AchievementCertificate,
  },
  {
    path: "/:organization_name/:id/certificate",
    component: CertificateParticipant,
  },
  {
    path: "/:organization_name/:id/COA-verification",
    component: COAVerification,
  },
  {
    path: "/:organization_name/:id/COP-verification",
    component: COPVerification,
  },
];
//organization dashboard
const hrAdminAuthProtectedRoutes = [
  {
    path: "/:organization_name/dashboard-organization",
    component: DashboardOrganization,
  },
  { path: "/:organization_name/add-staff", component: StaffRegister },
  { path: "/add-organization", component: OrganizationRegister },
  { path: "/organization-list", component: OrganizationList },
  { path: "/staff-info/:id", component: StaffInfo },
  {
    path: "/:organization_name/databaseadmin-list",
    component: DatabaseadminList,
  },
  { path: "/:organization_name/csr-list", component: csrList },
  {
    path: "/:organization_name/registration-admin-list",
    component: RegistrationAdminList,
  },
  { path: "/:organization_name/all-participants", component: AllParticipant },
];

const authProtectedRoutes = [
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
];

const accountantAuthProtectedRoutes = [
  {
    path: "/:organization_name/dashboard-accountant",
    component: DashboardAccountant,
  },
  { path: "/:organization_name/accountant-list", component: AccountantList },
  {
    path: "/:organizatiin_name/accountant-History",
    component: AccountantHistory,
  },
  {
    path: "/:organization_name/payment-statement",
    component: Paymentstatement,
  },
];

const dispatcherAuthProtectedRoute = [
  {
    path: "/:organization_name/dashboard-dispatcher",
    component: DashboardDispatcher,
  },
  { path: "/:organization_name/dispatcher-list", component: DispatcherList },
  {
    path: "/:organization_name/dispatcher-history",
    component: DispatcherHistory,
  },
];

export {
  authProtectedRoutes,
  labAuthProtectedRoutes,
  participantsAuthProtectedRoutes,
  financeOfficerAuthProtectedRoutes,
  databaseAdminAuthProtectedRoutes,
  registrationAdminAuthProtectedRoutes,
  CSRAdminAuthProtectedRoutes,
  hrAdminAuthProtectedRoutes,
  accountantAuthProtectedRoutes,
  dispatcherAuthProtectedRoute,
  publicRoutes,
};
